import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useAdminAuth } from '../../app/providers/useAdminAuth';
import { Button } from '../ui/Button';
import { AdminLanguageSwitcher } from './AdminLanguageSwitcher';
import styles from './Topbar.module.css';

const PATH_TO_NAV_KEY: Record<string, string> = {
  '/dashboard': 'dashboard',
  '/users': 'users',
  '/admins': 'admins',
  '/settings': 'settings',
  '/logs': 'logs',
};

// PARA-106 §3/§7 (UI-архитектура) — заголовок текущей страницы (по маршруту) +
// "Выход" + AdminLanguageSwitcher.
export function Topbar(): JSX.Element {
  const { t } = useTranslation();
  const { logout } = useAdminAuth();
  const { pathname } = useLocation();
  const navKey = PATH_TO_NAV_KEY[pathname] ?? 'dashboard';

  return (
    <header className={styles.topbar}>
      <span className={styles.title}>{t(`nav.${navKey}`)}</span>
      <div className={styles.actions}>
        <AdminLanguageSwitcher />
        <Button variant="ghost" size="sm" onClick={logout}>
          {t('topbar.logout')}
        </Button>
      </div>
    </header>
  );
}
